const parseApiErrors = (error: Global.ApiError): Global.ReturnError => {
  return {
    messageCode: error?.data?.statusCode || 500,
    messageTitle: error?.data?.name || "Unknown Error",
    messageText: error?.data?.message || "An unknown error occurs.",
  };
};

export default parseApiErrors;
